import React from 'react';
import { motion } from 'framer-motion';
import styles from './SectionHead.module.css';

const ease = [0.22, 1, 0.36, 1];
const wrap = { hidden: {}, show: { transition: { staggerChildren: 0.045 } } };
const word = { hidden: { y: '110%' }, show: { y: '0%', transition: { duration: 0.7, ease } } };
const fade = { hidden: { opacity: 0, y: 12, filter: 'blur(6px)' }, show: { opacity: 1, y: 0, filter: 'blur(0px)', transition: { duration: 0.7, delay: 0.25, ease } } };

/**
 * Section title + one-line intro, revealed word by word on scroll.
 * as: heading level (default h2). align: left | center. dark: on dark backgrounds.
 */
export default function SectionHead({ title, intro, align = 'left', dark = false, id, as: Tag = 'h2' }) {
    const MotionTag = motion[Tag] || motion.h2;
    return (
        <motion.div
            className={`${styles.head} ${align === 'center' ? styles.center : ''} ${dark ? styles.dark : ''}`}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.6 }}
        >
            <MotionTag id={id} variants={wrap} aria-label={title}>
                {title.split(' ').map((w, i) => (
                    <span key={i} className={styles.mask} aria-hidden="true">
                        <motion.span className={styles.word} variants={word}>{w}</motion.span>
                    </span>
                ))}
            </MotionTag>
            {intro && <motion.p variants={fade}>{intro}</motion.p>}
        </motion.div>
    );
}
